// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","tooltip":"tooltip_tooltip__ifkbI","tooltip__BOTTOM":"tooltip_tooltip__BOTTOM__BNstS","tooltipWrapper":"tooltip_tooltipWrapper__0SvP4"};